import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { TopicService } from '../topic.service';
import { Location } from '@angular/common';

import { NumberCardsService } from '../number-cards.service';
import { SuperExerciseComponent } from '../super-exercise/super-exercise.component';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-number-cards-reduce-bucket',
  templateUrl: './number-cards-reduce-bucket.component.html',
  styleUrls: ['../topic-style.css', './number-cards-reduce-bucket.component.css']
})
export class NumberCardsReduceBucketComponent extends SuperExerciseComponent {

  //typespecifics
  useBucket: boolean = false;
  visualRepresentation: string = "card";

  //helpers
  private value: number = 0;
  private buckets: number[] = [];
  private size: number[] = [];


  //solution
  private showErrorTransform: boolean = false;
  private feedbackType: string;

  constructor(protected activatedRoute: ActivatedRoute, public numberCardsService: NumberCardsService, protected topicService: TopicService, protected messageService: MessageService) {
    super(numberCardsService, activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    super.setTypeSpecificsFromConfiguration();
    let typespecs = this.configuration.typespecifics;
    let count = this.configuration.typespecifics["givenCards"];
    let index = 0;
    let oldCard = null;
    for (let card of this.cards) {
      this.count[card] = count[index];
      if (oldCard != null) {
        this.size[card] = oldCard / card;
      }
      oldCard = card;
      index++;
    }
    this.buckets = this.numberCardsService.getCount(this.cards);
    this.useBucket = this.configuration.typespecifics["useBucket"];
    this.solution = this.numberCardsService.getSolution(this.numberCardsService.getValue(this.count), this.cards);
    this.visualRepresentation = this.configuration.typespecifics.visualRepresentation;

    this.printable = this.visualRepresentation == "card";
  }

  setTypeSpecificsFromState() {
    super.setTypeSpecificsFromState();
    let buckets = this.state.typespecific.buckets;
    if (buckets != undefined) {
      let i: number = 0;
      for (let card of this.cards) {
        this.buckets[card] = buckets[i];
        i++;
      }
    }
  }
  
  computeState() {
    this.state.typespecific.count = [];
    this.state.typespecific.buckets = [];
    for (let card of this.cards) {
      this.state.typespecific.count.push(this.count[card]);
      this.state.typespecific.buckets.push(this.buckets[card]);
    }
  }

  /** when a card is place in the bucket, we need to perform some actions */
  addCardToBucket(card) {
    if (this.buckets[card] == this.size[card]) {
      this.messageService.addAlertWithTimeout(this.get("erroraddCardToBucket"), "danger", 3000);
      return;
    }
    this.count[card]--;
    this.buckets[card]++;

  }

  /** transform full bucket */
  transformBucket(card: number) {
    if (this.buckets[card] < this.size[card]) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransform"), "danger", 3000);

      return;
    }
    this.buckets[card] = 0;
    this.count[this.cards[this.cards.indexOf(card) - 1]] += 1;
  }

  /** transform full bucket */
  transformCards(card: number) {
    if (this.buckets[card] > this.count[card]) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransformNotEnoughCards"), "danger", 3000);
      return;
    }
    if (this.buckets[card] < this.size[card]) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransform"), "danger", 3000);
      return;
    }
    if (this.buckets[card] % this.size[card] != 0) {
      this.messageService.addAlertWithTimeout(this.get("errorReduceTransformWrongNumber"), "danger", 3000);
      return;
    }

    this.count[this.cards[this.cards.indexOf(card) - 1]] += this.buckets[card] / this.size[card];
    this.count[card] -= this.buckets[card];
    this.buckets[card] = 0;
  }

  /** empty bucket again */
  emptyBucket(card) {
    this.count[card] += this.buckets[card];
    this.buckets[card] = 0;
  }

  /** checks, whether the solution is correct or not */
  checkSolution(): void {
    let error = false;
    this.error = [];
    this.feedback = "";
    for (let card of this.cards) {
      if ((this.buckets[card] != 0 && this.buckets[card] != undefined)) {
        error = true;
      }
    }
    if (error) {
      this.feedback = this.feedback.concat(this.get("errorNonEmptyBucket"), "\n");
    }
    for (let i = 0; i < this.cards.length; i++) {
      if (this.solution[i] != this.count[this.cards[i]]) {
        error = true;
        if (this.showSymbols) {
          this.error.push(this.cards[i]);
        }
        if (this.showHelptext) {
          if (this.solution[i] > this.count[this.cards[i]]) {
            this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
          } else {
            this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
          }
        }
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);

    } else {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();

    }
  }

  /** evaluates the current state of the exercise 
   * @returns {number} - returns the total number of points (unweigthed, the maximum is 1)
  */
  evaluate(): number[] {
    let result = 0;
    let r = 0;
    let index = 0;
    for(let counts of this.solution){
      if (counts == this.count[this.cards[index]] && counts > 0){
        result++;
      }
      if(counts > 0) {
        r++;
      }
      index++;
    }
    return [2*result / r,2];
  }
}
